/* =================== BUSCA HEADER =================== */
jQuery(document).ready(function ($) {
  // Exibe / Oculta busca
  $(".segura-menu-mobile-pesquisa").on("click", function () {
    $(".segura-menu-mobile-barra-pesquisa").slideToggle();
  });
});
